// src/components/screener/ColumnPicker.jsx
// Extracted from ScreenerPage.jsx (SCREENER-FRAG).
// Content unchanged except: previously the parent owned `showColPicker` state
// and passed it down — now this component owns its own open/closed state
// internally, since nothing outside it ever needed to read or control that
// value. One less piece of state the parent (and future features) has to
// know exists.
//
// Props:
//   visibleCols     Set<string>  — currently selected column keys
//   onToggleColumn  (colKey) => void — parent applies the toggle to its own
//                   visibleCols state (used both for rendering extra table
//                   columns and in the D3 signal payload's columnsSelected)

import React, { useState } from 'react';
import { S, TECH_COLUMNS } from '../../constants/screenerConfig';

export default function ColumnPicker({ visibleCols, onToggleColumn }) {
  const [showColPicker, setShowColPicker] = useState(false);

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setShowColPicker(v => !v)}
        title="Select technical columns"
        style={{
          padding: '7px 12px', borderRadius: 8, fontSize: 12, fontWeight: 600,
          background: visibleCols.size > 0 ? 'rgba(59,130,246,0.12)' : 'transparent',
          color: visibleCols.size > 0 ? S.blue : S.muted,
          border: `1px solid ${visibleCols.size > 0 ? S.blue : S.border2}`,
          cursor: 'pointer', fontFamily: 'inherit',
        }}
      >
        ⊞ Columns{visibleCols.size > 0 ? ` (${visibleCols.size})` : ''}
      </button>
      {showColPicker && (
        <div style={{
          position: 'absolute', right: 0, top: '110%', zIndex: 50,
          background: S.surface, border: `1px solid ${S.border2}`,
          borderRadius: 10, padding: '12px 14px', minWidth: 200,
          boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
        }}>
          <div style={{ fontSize: 11, color: S.muted, fontWeight: 700, marginBottom: 10, letterSpacing: '0.06em' }}>
            TECHNICAL COLUMNS
          </div>
          {TECH_COLUMNS.map(col => (
            <label
              key={col.key}
              title={col.title}
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                fontSize: 13, color: S.text, cursor: 'pointer',
                padding: '5px 0', userSelect: 'none',
              }}
            >
              <input
                type="checkbox"
                checked={visibleCols.has(col.key)}
                onChange={() => onToggleColumn(col.key)}
                style={{ accentColor: S.purple, cursor: 'pointer' }}
              />
              {col.label}
              <span style={{ fontSize: 10, color: S.subtle, marginLeft: 'auto' }}>ℹ</span>
            </label>
          ))}
          <div style={{ fontSize: 10, color: S.subtle, marginTop: 10, lineHeight: 1.5 }}>
            RSI coming in S27K
          </div>
        </div>
      )}
    </div>
  );
}
